<template>
  <mdb-container>
    <mdb-row>
      <mdb-card-title>
        <strong> Configure this station</strong>
      </mdb-card-title>
    </mdb-row>

    <mdb-row>
      <StationConfig />
    </mdb-row>
  </mdb-container>
</template>

<script>
import StationConfig from "@/components/StationConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "Settings",
  components: {
    StationConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
